import React from "react";
import { cn } from "../../lib/utils"; 

export const Label = ({ className, children, ...props }) => {
  return (
    <label className={cn("text-gray-700 font-medium", className)} {...props}>
      {children}
    </label>
  );
};
